import React from 'react';
import { useField } from 'formik';
import {
  IconValidationInvalid,
  TextInput,
  TextInputProps,
} from '@adc/parallax-component-library';

type Props = {
  name: string;
  label: string | null;
  disabled?: boolean;
} & Partial<TextInputProps>;

const TextInputWithError = ({
  name,
  label,
  disabled = false,
  supportingText = '',
  ...rest
}: Props) => {
  const [field, meta] = useField(name);

  return (
    <TextInput
      {...(rest as TextInputProps)}
      label={label}
      error={!!(meta.touched && meta.error)}
      supportingText={
        meta.touched && meta.error && !disabled ? meta.error : supportingText
      }
      onChangeText={field.onChange(name)}
      onBlur={field.onBlur(name)}
      value={field.value}
      disabled={disabled}
      supportingIconConfig={
        meta.touched && meta.error
          ? { icon: <IconValidationInvalid /> }
          : undefined
      }
      width="100%"
    />
  );
};

export default TextInputWithError;
